import React from 'react';
import VerticalList from '@boschebike/ebds-react/dist-esm/components/VerticalList.js';

/**
 * @typedef {import('../../App.d.ts').ComponentVerticalListProps} ComponentVerticalListProps
 */
/**
 * @param {ComponentVerticalListProps} props
 * @returns {React.js.Element}
 * @constructor
 */
export default ({ items }) => (
  <VerticalList
    items={items}
  />
);
